import * as React from "react";
import { Button, Tooltip, ActionIcon } from "@mantine/core";
import { FlaskConical } from "lucide-react";

interface OpenPlaygroundButtonProps {
    onClick: () => void;
}

export function OpenPlaygroundButton({ onClick }: OpenPlaygroundButtonProps) {
    return (
        <React.Fragment>
            <Tooltip label="Playground">
                <ActionIcon
                    variant="light"
                    size="lg"
                    onClick={onClick}
                    hiddenFrom="sm"
                >
                    <FlaskConical size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                variant="light"
                color="gray"
                leftSection={<FlaskConical size={16} />}
                onClick={onClick}
                visibleFrom="sm"
            >
                Playground
            </Button>
        </React.Fragment>
    );
}
